import React from 'react';
import styles from './SectionTitle.module.scss';
interface SectionTitleProps {
    title: string;
}
const SectionTitle = ({ title }: SectionTitleProps) => {
    return (
        <div className={`${styles.title} ${styles.relative}`}>
            <h1 data-title={title}>{title}</h1>
        </div>
    );
};

export default SectionTitle;
